import styles from './InputControls.module.css';
import Slider from "../Slider/Slider";
import { useInputControls } from '../../hooks/useInputControls';

export default function InputControls({ sendCommand }) {
    const {
        mixSlider,
        mixActual,
        attackSlider,
        attackActual,
        releaseSlider,
        releaseActual,
        filterModSlider,
        filterModActual,
        handleMixChange,
        handleAttackChange,
        handleReleaseChange,
        handleFilterModChange
    } = useInputControls(sendCommand);

    return (
        <div className={styles.section}>
            <div className={styles.container}>
                <h2 className={styles.header}>Input Control</h2>
                <div className={styles.controlsFrame}>
                    <Slider
                        label="Dry/Wet"
                        value={mixSlider}
                        onChange={handleMixChange}
                        displayValue={`${(mixActual * 100).toFixed(0)}% dry`}
                    />
                    <Slider
                        label="Attack"
                        value={attackSlider}
                        onChange={handleAttackChange}
                        displayValue={`${attackActual.toFixed(0)} ms`}
                    />
                    <Slider
                        label="Release"
                        value={releaseSlider}
                        onChange={handleReleaseChange}
                        displayValue={`${releaseActual.toFixed(0)} ms`}
                    />
                    <Slider
                        label="Filter Mod"
                        value={filterModSlider}
                        onChange={handleFilterModChange}
                        displayValue={filterModActual.toFixed(2)}
                    />
                </div>
            </div>
        </div>
    );
}
